window.addEventListener('load', ()=> {
  // Code to show loader only before the DOM content is loaded
  setTimeout(() => {
    const loader = document.getElementById('abi-jsLoading');
    loader.classList.add('hide');
  }, 1000);
})
